module.exports = __webpack_public_path__ + "static/media/chat03-1.e42f743e.svg";